"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReactivateWeeklyCoachingSubscriptionPayload = exports.isCancelWeeklyCoachingSubscriptionPayload = exports.isConfirmWeeklyCoachingCheckoutPayload = exports.isInitiateWeeklyCoachingCheckoutData = exports.isInitiateWeeklyCoachingCheckoutPayload = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const chargebee_models_1 = require("../models/chargebee_models");
const language_codes_types_1 = require("../models/language_codes_types");
// initiateWeeklyCoachingCheckout
// Payload
const InitiateWeeklyCoachingCheckoutPayloadSchema = zod_1.z.object({
    langPairCode: language_codes_types_1.LanguagePairCodeSchema,
    planId: zod_1.z.string(),
});
exports.isInitiateWeeklyCoachingCheckoutPayload = type_validation_helpers_1.getTypeValidationFunction(InitiateWeeklyCoachingCheckoutPayloadSchema);
const isInitiateWeeklyCoachingCheckoutData = (v) => chargebee_models_1.isHostedPage(v);
exports.isInitiateWeeklyCoachingCheckoutData = isInitiateWeeklyCoachingCheckoutData;
// confirmWeeklyCoachingCheckout
// Payload
const ConfirmWeeklyCoachingCheckoutPayloadSchema = zod_1.z.object({
    checkoutId: zod_1.z.string(),
});
exports.isConfirmWeeklyCoachingCheckoutPayload = type_validation_helpers_1.getTypeValidationFunction(ConfirmWeeklyCoachingCheckoutPayloadSchema);
// cancelWeeklyCoachingSubscription
// Payload
const CancelWeeklyCoachingSubscriptionPayloadSchema = zod_1.z.object({
    subscriptionId: zod_1.z.string(),
});
const isCancelWeeklyCoachingSubscriptionPayload = (v) => CancelWeeklyCoachingSubscriptionPayloadSchema.safeParse(v).success;
exports.isCancelWeeklyCoachingSubscriptionPayload = isCancelWeeklyCoachingSubscriptionPayload;
// reactivateWeeklyCoachingSubscription
// Payload
const ReactivateWeeklyCoachingSubscriptionPayloadSchema = zod_1.z.object({
    subscriptionId: zod_1.z.string(),
});
exports.isReactivateWeeklyCoachingSubscriptionPayload = type_validation_helpers_1.getTypeValidationFunction(ReactivateWeeklyCoachingSubscriptionPayloadSchema);
//# sourceMappingURL=weekly_coaching_args.js.map